import moment from 'moment';

// Serializes a Date as a plain YYYY-MM-DD calendar day using LOCAL components.
// Unlike Date.toISOString(), this performs no timezone conversion, so a date picked at
// local midnight is sent as the same calendar day the user selected (no off-by-one for
// users ahead of UTC). Use for date-only filters such as DOS.
export default function toDateOnlyString(value) {
    if (!value) return null;
    return moment(value).format('YYYY-MM-DD');
}
